import React from 'react';
import { Typography } from 'ha/ui/next/Typography';
import { withIntl, IntlProps } from 'ha/i18n';
import Grid from 'ha/ui/next/Grid';
import { RulesValue, RulesFilterValue } from 'ha/types/SearchFilters';

import FilterCheckbox from './FilterCheckbox';

interface Props {
  rules: RulesFilterValue;
  onToggle: (type: string, selected: boolean) => void;
}

export const RulesFilter: React.FC<Props & IntlProps> = ({
  rules,
  onToggle,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography.ParagraphTitle data-test-locator="RulesFilter Title">
      {T('Rules')}
    </Typography.ParagraphTitle>

    <Grid container>
      <Grid item md={6}>
        <FilterCheckbox
          name={`${RulesValue.SMOKING}-checkbox`}
          isActive={rules.includes(RulesValue.SMOKING)}
          onToggle={(selected: boolean) =>
            onToggle(RulesValue.SMOKING, selected)
          }
          data-test-locator="RulesFilter SmokingAllowed"
        >
          <Typography.Paragraph noWrap>
            {T('Smoking allowed')}
          </Typography.Paragraph>
        </FilterCheckbox>
      </Grid>
      <Grid item md={6}>
        <FilterCheckbox
          name={`${RulesValue.PETS}-checkbox`}
          isActive={rules.includes(RulesValue.PETS)}
          onToggle={(selected: boolean) => onToggle(RulesValue.PETS, selected)}
          data-test-locator="RulesFilter PetsAllowed"
        >
          <Typography.Paragraph noWrap>
            {T('Pets allowed')}
          </Typography.Paragraph>
        </FilterCheckbox>
      </Grid>
      <Grid item md={6}>
        <FilterCheckbox
          name={`${RulesValue.INSTRUMENT}-checkbox`}
          isActive={rules.includes(RulesValue.INSTRUMENT)}
          onToggle={(selected: boolean) =>
            onToggle(RulesValue.INSTRUMENT, selected)
          }
          data-test-locator="RulesFilter PlayingInstrumentAllowed"
        >
          <Typography.Paragraph noWrap>
            {T('Playing instrument allowed')}
          </Typography.Paragraph>
        </FilterCheckbox>
      </Grid>
    </Grid>
  </React.Fragment>
);

export default withIntl(RulesFilter);
